/*@ngInject*/
const nl2brFilter = function ($sanitize) {
    return function (msg) {
        // nl2br has issue with linky filter so wrote custom filter
        // Source: https://stackoverflow.com/questions/28089736/how-to-use-nl2br-and-linky-filter-together-in-angularjs
        // ngSanitize's linky filter changes \r and \n to &#10; and &#13; respectively
        msg = (msg + '').replace(/(\r\n|\n\r|\r|\n|&#10;&#13;|&#13;&#10;|&#10;|&#13;)/g, '<br />' + '$1');
        return $sanitize(msg);
    };
};

angular.module('umCore')
    .filter('nl2br', nl2brFilter);
